import React from "react";
import { Form } from "react-bootstrap";

interface CustomTypeSelectionProps {
  label: string;
  options: { label: string; value: string }[];
  selected: string[];
  onChange: (value: string) => void;
  onOtherChange?: (value: string) => void;
}

export const CustomTypeSelection: React.FC<CustomTypeSelectionProps> = ({
  label,
  options,
  selected,
  onChange,
  onOtherChange,
}) => {
  return (
    <Form.Group className="mt-1">
      <Form.Label style={{ color: '#ffffff' }}>{label}</Form.Label>
      {options.map((option, index) => {
        const id = `custom-checkbox-${option.value}-${index}`;
        return (
          <div key={option.value} className="d-flex align-items-baseline gap-2">
            <Form.Check
              id={id}
              type="checkbox"
              checked={selected.includes(option.value)}
              onChange={() => onChange(option.value)}
              className="mt-1"
            />
            <Form.Label
              htmlFor={id}
              className="form-check-label"
              style={{ cursor: "pointer", color: '#ffffff' }}
            >
              {option.label}
            </Form.Label>
          </div>
        );
      })}
      {selected.includes("other") && (
        <Form.Control
          type="text"
          placeholder="Please specify..."
          className="mt-1"
          onChange={(e) => onOtherChange?.(e.target.value)}
        />
      )}
    </Form.Group>
  );
};
